export const BaseUrl = "https://api.3genconsulting.com/";

// Authentication remains compatible with the existing admin login. RBAC data and
// permission decisions are never persisted in localStorage.
